import { render, staticRenderFns } from "./firstGoodsList.vue?vue&type=template&id=16757dc6&scoped=true"
import script from "./firstGoodsList.vue?vue&type=script&lang=js"
export * from "./firstGoodsList.vue?vue&type=script&lang=js"
import style0 from "./firstGoodsList.vue?vue&type=style&index=0&id=16757dc6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16757dc6",
  null
  
)

export default component.exports